import {LoginService} from 'app/main/auth/login/login.service'
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation, inject, input, OnDestroy } from '@angular/core';
import {merge, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {CdkNavigationService} from '@cdk/components/navigation/navigation.service';
import {CdkNavigation} from '../../types';
import { NgClass } from '@angular/common';
import { CdkNavVerticalGroupComponent } from './vertical/group/group.component';
import { CdkNavVerticalCollapsableComponent } from './vertical/collapsable/collapsable.component';
import { CdkNavVerticalItemComponent } from './vertical/item/item.component';
import { CdkNavHorizontalCollapsableComponent } from './horizontal/collapsable/collapsable.component';
import { CdkNavHorizontalItemComponent } from './horizontal/item/item.component';

@Component({
    selector: 'cdk-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
        imports: [NgClass, CdkNavVerticalGroupComponent, CdkNavVerticalCollapsableComponent, CdkNavVerticalItemComponent, CdkNavHorizontalCollapsableComponent, CdkNavHorizontalItemComponent],
    providers: [
      LoginService
    ]
})
export class CdkNavigationComponent implements OnInit, OnDestroy {
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _cdkNavigationService = inject(CdkNavigationService);

    readonly layout = input('vertical');

    @Input()
    navigation: CdkNavigation[];

    // Private
    private _unsubscribeAll: Subject<any>;



    constructor() {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Load the navigation either from the input or from the service
        this.navigation = this.navigation || this._cdkNavigationService.getCurrentNavigation();
        // Subscribe to the current navigation changes
        this._cdkNavigationService.onNavigationChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {

                // Load the navigation
                this.navigation = this._cdkNavigationService.getCurrentNavigation();

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

        // Subscribe to navigation item
        merge(
            this._cdkNavigationService.onNavigationItemAdded,
            this._cdkNavigationService.onNavigationItemUpdated,
            this._cdkNavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }
}
